var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPundix(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_64_377)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m26.942 6.942-2.084-2.085-7.816 7.816 2.084 2.084 7.816-7.815zM14.958 18.925l-2.084-2.084-7.816 7.816 2.085 2.084 7.815-7.815zm9.9 7.816 2.084-2.084-7.816-7.815-2.084 2.085 7.816 7.816zM12.873 14.757l2.084-2.084-7.815-7.816-2.085 2.085 7.816 7.815zm5.21 1.042L16 13.714l-2.084 2.084L16 17.882l2.084-2.084z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_64_377"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPundix);
export default __webpack_public_path__ + "static/media/PUNDIX.93190029cb8461c0316e254aa9b1eae1.svg";
export { ForwardRef as ReactComponent };